export default class AuthService
{
    static USERNAME: string = '';
    static TOKEN: string = '';
}